export const TELESRV_NAME = 'TheCat';
export const TELESRV_WEB_K_NAME = 'TheCat Web K';
export const TELESRV_SCHEME = 'thecat';
export const TELESRV_PUBLIC_HOST = 'cr0.ir';
export const TELESRV_PUBLIC_URL = `https://${TELESRV_PUBLIC_HOST}`;
export const TELESRV_WEB_A_URL = 'https://weba.cr0.ir/';
export const TELESRV_WEB_K_URL = 'https://webk.cr0.ir/';
export const TELESRV_WEB_DOMAINS = ['weba.cr0.ir', 'webk.cr0.ir'];
